import React from "react";
import { Button, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Icons
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import TvIcon from "@mui/icons-material/Tv";
import InfoIcon from "@mui/icons-material/Info";

function NavMenu() {
  const navigate = useNavigate();
  return (
    <>
      <Button
        color="inherit"
        sx={{ textTransform: "unset", fontSize: { xs: "small", sm: "small" } }}
        onClick={() => navigate("/contact_us")}
      >
        <ContactSupportIcon fontSize="small" sx={{ mr: 1 }} />
        Contact SchoolMidas{" "}
      </Button>
      <Divider
        orientation="vertical"
        sx={{ height: 28, mx: 1, my: 2, backgroundColor: "white" }}
      />
      <Button
        color="inherit"
        sx={{ textTransform: "unset", fontSize: { xs: "small", sm: "small" } }}
        onClick={() => navigate("/demo")}
      >
        <TvIcon fontSize="small" sx={{ mr: 1 }} /> Request a Demo
      </Button>
    </>
  );
}

export default NavMenu;
